<app-alert-html
  [errorHtml]="null"
  (close)="null"
>
</app-alert-html>

<div class="container-fluid mt-3">
  <div class="row mb-3">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h3 style="color: #719eb6; font-weight: bold;">
        Staff Management Report
      </h3>
      <div class="d-flex gap-2">
        <p-button
          icon="pi pi-filter"
          label="Filters"
          class="p-button-outlined side-menu-button2"
          (onClick)="filtersPanel.toggle($event)"
        />
        <p-button
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined side-menu-button2"
          (onClick)="exportToExcel()"
          [disabled]="isLoadingReport() || !filteredRows().length"
        />
      </div>
    </div>
  </div>

  <p-overlayPanel
    #filtersPanel
    [showCloseIcon]="true"
    [dismissable]="true"
    styleClass="staff-report-filters-panel"
  >
    <div class="container-fluid staff-report-filters">
      <div class="row mb-3">
        <div class="col-md-6 mb-2">
          <label class="fw-bold" style="color: #719eb6;">Programs: </label>
          <br />
          <p-multiSelect
            appendTo="body"
            [options]="programs()"
            [(ngModel)]="selectedProgramIDs"
            [showClear]="true"
            defaultLabel="All Programs"
            optionLabel="ProgramName"
            optionValue="ID"
          >
          </p-multiSelect>
        </div>

        <div class="col-md-6 mb-2">
          <label class="fw-bold" style="color: #719eb6;">Targets: </label>
          <br />
          <p-multiSelect
            appendTo="body"
            [options]="targets()"
            [(ngModel)]="selectedTargetIDs"
            [showClear]="true"
            defaultLabel="All Targets"
            optionLabel="TargetName"
            optionValue="ID"
          >
          </p-multiSelect>
        </div>

        <div class="col-md-6 mb-2">
          <label class="fw-bold" style="color: #719eb6;">Staff: </label>
          <br />
          <p-multiSelect
            appendTo="body"
            [options]="staffOptions()"
            [(ngModel)]="selectedStaffIDs"
            [showClear]="true"
            defaultLabel="All Staff"
            optionLabel="label"
            optionValue="value"
          >
          </p-multiSelect>
        </div>

        <div class="col-md-6 mb-2">
          <label class="fw-bold" style="color: #719eb6;">
            Date Range: 
          </label>
          <br />
          <div class="">
            From: <input
              type="date"
              class="form-control ms-1 me-1"
              [(ngModel)]="startDate"
            />
            To: <input
              type="date"
              class="form-control ms-1 me-1"
              [(ngModel)]="endDate"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex justify-content-end gap-2">
          <button
            pButton
            class="p-button-outlined side-menu-button2"
            icon="pi pi-filter"
            (click)="loadReport(); filtersPanel.hide()"
            [disabled]="isLoadingReport()"
          >
            Apply
          </button>
          <button
            pButton
            class="p-button-outlined switch-mode-button"
            icon="pi pi-refresh"
            (click)="clearFilters(); loadReport(); filtersPanel.hide()"
            [disabled]="isLoadingReport()"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </p-overlayPanel>

  <!-- Report Table -->
  <div class="row">
    <div class="col-12">
      @if (isLoadingReport() || isLoading) {
        <app-loading-indicator />
      } @else {
        @if (!report() || !filteredRows().length) {
          <div class="text-center mt-4" style="color: #719eb6;">
            No data found for the selected filters.
          </div>
        } @else {
          <p-table
            [value]="filteredRows()"
            [scrollable]="true"
            [scrollHeight]="'flex'"
            [scrollDirection]="'both'"
            styleClass="staff-report-table p-datatable-sm"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Session Date</th>
                <th>Staff</th>
                <th
                  *ngFor="let col of report()?.Columns; let colIndex = index"
                  class="text-center"
                >
                  {{ col.TargetName }}
                  <br />
                  <small *ngIf="col.DesiredTrials">
                    Desired: {{ col.DesiredTrials }}
                  </small>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
              <tr>
                <td>
                  {{ row.SessionStartedDate | date: 'MM/dd/yyyy hh:mm a' }}
                </td>
                <td>
                  {{ row.StaffName }}
                </td>
                <td
                  *ngFor="let col of report()?.Columns; let colIndex = index"
                  class="text-center"
                  [ngClass]="{
                    'text-danger fw-bold': isUnderTarget(rowIndex, colIndex),
                    'text-success fw-bold': !isUnderTarget(rowIndex, colIndex)
                  }"
                >
                  {{ getCellText(rowIndex, colIndex) }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        }
      }
    </div>
  </div>
</div>


